import { GetApprovalFilterRequest } from '../types/dto/worklogs-approval.dto';

export const APPROVALS_QUERY_KEYS = Object.freeze({
  all: ['approvals'],
  // Filter-agnostic prefixes for invalidation/patching (match every filter variant of a level).
  projectsAll: ['approvals', 'projects'],
  summaryAll: ['approvals', 'summary'],
  membersAll: ['approvals', 'members'],
  worklogsAll: ['approvals', 'worklogs'],
  projects: (filter: GetApprovalFilterRequest) => ['approvals', 'projects', filter],
  summary: (filter: GetApprovalFilterRequest) => ['approvals', 'summary', filter],
  members: (projectId: number, filter: GetApprovalFilterRequest) => [
    'approvals',
    'members',
    projectId,
    filter,
  ],
  worklogs: (projectId: number, memberId: number, filter: GetApprovalFilterRequest) => [
    'approvals',
    'worklogs',
    projectId,
    memberId,
    filter,
  ],
});
